import { useApi } from './use-api-call';


export const useSearchSettingApi = () => useApi<{ 
settings: SettingDTO[];
        allowEdit: boolean; 
    }>('/setting/search-setting');

export const useGetSettingApi = () => useApi<{ setting: SettingDTO; allowEdit: boolean; }>('/setting/get-setting/{id}');

export const useSaveSettingApi = () => useApi<{ setting: SettingDTO}>('/setting/save-setting');

export const useDeleteSettingApi = () => useApi('/setting/delete-setting/{id}');

export interface SettingDTO { 
id:string;
value:string;
createdAt?:Date;
createdBy?:string;
modifiedAt?:Date;
modifiedBy?:string;
}
